import { ConvertStringToHtmlId } from "../../../../../libs/ts/ConvertStringToHtmlId"

export interface props {
    link: string,
    linkText: string,
    className?: string,
    textFollowingLink?: string
}

export const ExternalLink = (props: props) => {
    return (
        <div className={`pb-7 ${props.className}`}>
            <span><a className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} pb-1 font-bold border-b-[2px] text-interactive-coral hover:text-solid-bold-green hover:border-solid-bold-green visited:text-interactive-coral-db-70`} href={`${props.link}`}>{props.linkText}</a> {props.textFollowingLink}</span>
        </div>
    )
}


export const ExternalFooterLink = (props: props) => {
    return (
        <div className={`pb-2 ${props.className}`}>
            <span><a className={`jbp-link-${ConvertStringToHtmlId(props.linkText)} text-white hover:text-solid-bold-green hover:border-solid-bold-green`} href={`${props.link}`}>{props.linkText}</a> {props.textFollowingLink}</span>
        </div>
    )
}
